import React from 'react'
import { Link } from 'react-router-dom'
import Star from '@components/Icon/Star'
import Avatar from '@components/Avatar'
import Delete from '@components/Icon/Delete'
import { observer } from 'mobx-react'
import propTypes from 'prop-types'
import moment from 'moment'

const targetInputStyle = {
	padding: 0,
	border: 'none',
	width: 65,
	marginTop: -1,
	marginLeft: 5
}

const EmployeeCard = observer(({ store, employee, removeEmployee }) => {
	if (!employee) {
		return ''
	}
	const { staticData, isEditable, nextMonthStart } = store
	const { EMPLOYEE_POSITIONS } = staticData.CONST
	const isLead = [
		EMPLOYEE_POSITIONS.ACCOUNT_MANAGER,
		EMPLOYEE_POSITIONS.TEAM_LEADER,
		EMPLOYEE_POSITIONS.PRINCIPAL
	].includes(employee.positionId)

	const nhFlag = employee.isNewAssociate ? 'NH' : ''
	const isNhLastMonth =
		nhFlag &&
		nextMonthStart.diff(
			moment(employee.newHireUntil).startOf('month'),
			'months'
		) === 1

	return (
		<div
			className="team--employee-card"
			key={employee.id}
			title={
				employee.status
					? ''
					: "This employee is inactive and can't access platform anymore. They should be removed from team structure."
			}>
			<Avatar src={employee.picture} />
			<div
				className="team--employee-card--container"
				id={`employee-${employee.id}`}
				data-team={employee.teamId}>
				<div>
					<Link to={'/employee/' + employee.id}>
						{employee.title} {employee.fullName} {nhFlag}
						{isNhLastMonth ? <sub>0</sub> : ''}
					</Link>
				</div>
				<div
					className={
						'team--position' +
						(isLead ? ' bold' : '') +
						(employee.status ? '' : ' red-text')
					}>
					{!employee.status && <span>Inactive </span>}
					<span>{employee.isSenior ? 'Senior ' : ''}{employee.position}</span>
				</div>
				<div style={{ display: 'flex' }}>
					<span>
						<Star />
					</span>
					<span style={{ marginTop: 3 }}>EUR</span>
					<input
						style={targetInputStyle}
						value={employee.targetMargin}
						onChange={e => {
							employee.targetMargin = e.target.value
						}}
						disabled={!store.isEditable}
						onBlur={async () => {
							const res = await store.updateEmployeeTargetMargin({
								employeeId: employee.id,
								targetMargin: employee.targetMargin
							})
							employee.targetMargin = res.targetMargin.toFixed(2)
						}}
						step="0.01"
						type="number"
					/>
				</div>
			</div>
			{isEditable && (
				<div className="team--employee-card--delete">
					{removeEmployee && (
						<Delete
							onClick={() => removeEmployee(employee.id, employee.teamId)}
						/>
					)}
				</div>
			)}
		</div>
	)
})

EmployeeCard.propTypes = {
	store: propTypes.object.isRequired,
	employee: propTypes.object.isRequired,
	removeEmployee: propTypes.func
}

export default EmployeeCard
